import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Menu,
  Modal,
  Pagination,
  Popover,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import memberApi from "../../../apis/MemberManage.api";
import userApi from "../../../apis/User.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const MemberManageComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [searchOptions, setSearchOptions] = useState({
    searchType: "total",
    searchValue: null,
    memberType: "general",
    dateType: "total",
    startDate: null,
    endDate: null,
  });
  const [orderType, setOrderType] = useState("created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [totalSize, setTotalSize] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [memberList, setMemberList] = useState([]);
  const [selectMember, setSelectMember] = useState({});
  const [isPointModalOpen, setIsPointModalOpen] = useState(false);
  const [pointHistory, setPointHistory] = useState({
    earn: 0,
    usage: 0,
    list: [],
  });
  const [isEarnPointPopoverOpen, setIsEarnPointPopoverOpen] = useState(false);
  const [earnPoint, setEarnPoint] = useState({
    point_content: null,
    point_score: null,
  });
  const [isMemberManageModalOpen, setIsMemberManageModalOpen] = useState({
    visible: false,
    type: null,
  });
  const [password, setPassword] = useState(null);
  const [error, setError] = useState("");

  const [expertList, setExpertList] = useState([]);
  const [channelJoinShow, setChannelJoinShow] = useState(false);
  const [navType, setNavType] = useState("mall"); // mall, app
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);

  const [memberTypeItems, setMemberTypeItems] = useState([
    { label: "일반", value: "general" },
    { label: "임직원", value: "admin" },
  ]);
  const [searchTypeItems, setSearchTypeItems] = useState([
    { searchType: "total", searchText: "전체검색" },
    { searchType: "id", searchText: "아이디" },
    { searchType: "nickname", searchText: "닉네임" },
    { searchType: "phone", searchText: "연락처" },
  ]);

  const dateTypeItems = [
    { label: "전체", value: "total" },
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
  ];

  const orderPair = {
    id: "아이디순",
    nickname: "닉네임순",
    point: "보유포인트순",
    created_at: "가입일순",
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      // for (const row of selectedRows) {
      // 	if (!editDeliveryInfo.hasOwnProperty(row.order_detail_id)) {
      // 		editDeliveryInfo[row.order_detail_id] = {
      // 			order_id: row.order_id,
      // 			order_detail_id: row.order_detail_id,
      // 			order_detail_status: "delivery_shipping",
      // 			delivery_company: row.delivery_company,
      // 			tracking_number: row.tracking_number,
      // 			ship_date:
      // 				row.ship_date === null || row.ship_date === ""
      // 					? moment()
      // 					: moment(row.ship_date),
      // 			updated_by: user.id === 724 ? 1 : user.id,
      // 		};
      // 	}
      // }
      // let difference = Object.keys(editDeliveryInfo).filter(
      // 	(orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey))
      // );
      // if (difference?.length !== 0) {
      // 	for (const orderDetailKey of difference) {
      // 		delete editDeliveryInfo[orderDetailKey];
      // 	}
      // }
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };

  const columns = [
    {
      title: "회원번호",
      // width: 120,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      // ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: "닉네임",
      // width: 120,
      dataIndex: "nickname",
      key: "nickname",
      // ellipsis: true
    },
    {
      title: "가입상태",
      // width: 120,
      dataIndex: "provider",
      key: "provider",
      // ellipsis: true
      render: (value) => {
        if (value) {
          return status.matchingProvider[value];
        } else {
          return "-";
        }
      },
    },
    {
      title: "휴대폰 번호",
      // width: 120,
      dataIndex: "phone",
      key: "phone",
      // ellipsis: true
    },
    {
      title: "포인트",
      // width: 120,
      dataIndex: "point",
      key: "point",
      // ellipsis: true
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (value) {
          return (
            <span
              className="member-search-table-highlight"
              onClick={() => {
                getPointHistoryListById(record.id);
                setSelectMember(record);
                setIsPointModalOpen(true);
              }}
            >
              {value.toLocaleString()}
            </span>
          );
        } else {
          return (
            <span
              className="member-search-table-highlight"
              onClick={() => {
                getPointHistoryListById(record.id);
                setSelectMember(record);
                setIsPointModalOpen(true);
              }}
            >
              0
            </span>
          );
        }
      },
    },
    {
      title: "임직원 여부",
      // width: 120,
      dataIndex: "is_admin",
      key: "is_admin",
      // ellipsis: true
      render: (value) => {
        return value ? "임직원" : "";
      },
    },
    {
      title: "가입일",
      // width: 120,
      dataIndex: "created_at",
      key: "created_at",
      // ellipsis: true
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return moment(value).format("YYYY.MM.DD");
        }
      },
    },
    {
      title: "최종접속일",
      // width: 120,
      dataIndex: "updated_at",
      key: "updated_at",
      // ellipsis: true
      render: (value, record) => {
        if (value) {
          return moment(value).format("YYYY.MM.DD");
        } else if (record.created_at) {
          return moment(record.created_at).format("YYYY.MM.DD");
        }
      },
    },
    {
      title: "회원관리",
      // width: 120,
      dataIndex: "",
      key: "",
      // ellipsis: true
      render: (value, record) => {
        return (
          <Row wrap={false} align="middle">
            <Button
              onClick={() => {
                setSelectMember(record);
                setIsMemberManageModalOpen({ visible: true, type: "withdraw" });
              }}
            >
              회원탈퇴
            </Button>
            {record.is_admin ? (
              <Button
                onClick={() => {
                  setSelectMember(record);
                  setIsMemberManageModalOpen({
                    visible: true,
                    type: "disallow",
                  });
                }}
              >
                관리자 탈퇴
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setSelectMember(record);
                  setIsMemberManageModalOpen({ visible: true, type: "allow" });
                }}
              >
                관리자 등록
              </Button>
            )}
          </Row>
        );
      },
    },
  ];
  const appColumns = [
    {
      title: "회원번호",
      width: 80,
      dataIndex: "id",
      key: "id",
      fixed: "left",
    },
    {
      title: "닉네임",
      width: 250,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "가입상태",
      width: 140,
      dataIndex: "provider",
      key: "provider",
      // ellipsis: true
      render: (value) => {
        if (value) {
          return status.matchingProvider[value];
        } else {
          return "휴대폰로그인";
        }
      },
    },
    {
      title: "가입일",
      width: 180,
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => {
        if (value) {
          return moment(value).format("YYYY.MM.DD");
        }
      },
    },
    {
      title: "가입채널",
      width: 180,
      dataIndex: "channel_name",
      key: "channel_name",
      align: "center",
      render: (value) => {
        if (value) {
          return value;
        } else {
          return "-";
        }
      },
    },
    {
      title: "회원관리",
      dataIndex: "",
      key: "",
      render: (value, record) => {
        if (!record?.channel_name) {
          return (
            <Row wrap={false} align="middle">
              <Button
                onClick={() => {
                  setSelectMember(record);
                  setChannelJoinShow(true);
                }}
              >
                채널 가입
              </Button>
            </Row>
          );
        }
      },
    },
  ];
  const pointColumns = [
    {
      title: "일시",
      width: 160,
      dataIndex: "created_at",
      key: "created_at",
      // ellipsis: true
      render: (value) => {
        if (value) {
          return moment(value).format("YYYY.MM.DD");
        }
      },
    },
    {
      title: "내용",
      // width: 120,
      dataIndex: "point_type",
      key: "point_type",
      // ellipsis: true
      render: (value, record) => {
        if (value.includes("admin")) {
          return record.point_content;
        } else if (status.matchingPointHistory.hasOwnProperty(value)) {
          return status.matchingPointHistory[value];
        } else {
          return value;
        }
      },
    },
    {
      title: "지급 포인트",
      width: 208,
      dataIndex: "",
      key: "",
      // ellipsis: true
      render: (_, record) => {
        if (
          record.point_type === "purchase_saving_point_complete" ||
          record.point_type === "purchase_complete" ||
          record.point_type === "review_complete" ||
          record.point_type === "admin_point_complete" ||
          record.point_type === "purchase_cancel"
        ) {
          return record.point_score.toLocaleString();
        } else {
          return "-";
        }
      },
    },
    {
      title: "사용 포인트",
      width: 208,
      dataIndex: "",
      key: "",
      // ellipsis: true
      render: (_, record) => {
        if (
          record.point_type !== "purchase_saving_point_complete" &&
          record.point_type !== "purchase_complete" &&
          record.point_type !== "review_complete" &&
          record.point_type !== "admin_point_complete" &&
          record.point_type !== "purchase_cancel"
        ) {
          return record.point_score.toLocaleString();
        } else {
          return "-";
        }
      },
    },
  ];

  // useEffect(() => {
  // 	if (navType === "mall") {
  // 		getReadMemberList("initial");
  // 	} else {
  // 		getAppReadMemberList("initial");
  // 	}
  // }, []);

  useEffect(() => {
    getExpertList();
  }, [navType]);

  useEffect(() => {
    if (navType === "mall") {
      getReadMemberList();
    } else {
      getAppReadMemberList();
    }
  }, [offset, pageSize, orderType, orderBy]);

  useEffect(() => {
    if (navType === "mall" && memberTypeItems[0]?.value === "general") {
      getReadMemberList("initial");
    } else {
      getAppReadMemberList("initial");
    }
  }, [memberTypeItems]);
  /**
   * 당영앱 전문가 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getExpertList = async () => {
    if (navType === "mall") {
      setMemberTypeItems([
        { label: "일반", value: "general" },
        { label: "임직원", value: "admin" },
      ]);
      setSearchTypeItems([
        { searchType: "total", searchText: "전체검색" },
        { searchType: "id", searchText: "아이디" },
        { searchType: "nickname", searchText: "닉네임" },
        { searchType: "phone", searchText: "연락처" },
      ]);
      setSearchOptions({
        ...searchOptions,
        memberType: "general",
      });
    } else {
      const res = await memberApi.readAppExpertList();
      if (res.code === 200) {
        setExpertList(res.result?.expertList ?? []);
        let list = res.result?.expertList;
        if (list?.length) {
          setMemberTypeItems([
            { label: "전체", value: 0 },
            { label: "미가입자", value: 999 },
            ...list.map((item) => ({
              label: item.name,
              value: item.channel_id,
            })),
          ]);
          setSearchOptions({
            ...searchOptions,
            memberType: 0,
          });
        } else {
          setMemberTypeItems([
            { label: "전체", value: 0 },
            { label: "미가입자", value: 999 },
          ]);
          setSearchOptions({
            ...searchOptions,
            memberType: 0,
          });
        }
      } else {
        setMemberTypeItems([
          { label: "전체", value: 0 },
          { label: "미가입자", value: 999 },
        ]);
        setSearchOptions({
          ...searchOptions,
          memberType: 0,
        });
      }

      setSearchTypeItems([
        { searchType: "total", searchText: "전체검색" },
        // { searchType: "id", searchText: "아이디" },
        { searchType: "nickname", searchText: "닉네임" },
        // { searchType: "phone", searchText: "연락처" },
      ]);
    }
  };

  const getReadMemberList = async (type = "") => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchTypeItems[0].searchType,
          searchValue: null,
          memberType: memberTypeItems[0].value,
          dateType: "total",
          startDate: null,
          endDate: null,
          orderType: "created_at",
          orderBy: "desc",
        };
      } else if (type === "search") {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          memberType: searchOptions.memberType,
          dateType: searchOptions.dateType,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format("YYYYMMDDHHmm")
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format("YYYYMMDDHHmm")
            : null,
          orderType: orderType,
          orderBy: orderBy,
        };
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          memberType: searchOptions.memberType,
          dateType: searchOptions.dateType,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format("YYYYMMDDHHmm")
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format("YYYYMMDDHHmm")
            : null,
          orderType: orderType,
          orderBy: orderBy,
        };
      }
      const res = await memberApi.readMemberList(param);
      if (res.code === 200) {
        setMemberList(res.result.userList);
        setTotalSize(res.result.totalCnt);
      } else {
        alert(
          "회원 목록을 조회해오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getReadMemberList read error", error);
    }
  };

  const [notRegisterValid, setNotRegisterValid] = useState(false);

  const getAppReadMemberList = async (type = "") => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchTypeItems[0].searchType,
          searchValue: null,
          memberType: memberTypeItems[0].value,
          dateType: "total",
          startDate: null,
          endDate: null,
          orderType: "created_at",
          orderBy: "desc",
        };
      } else if (type === "search") {
        param = {
          offset: 0,
          pageSize: 10,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          memberType: searchOptions.memberType,
          dateType: searchOptions.dateType,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format("YYYYMMDDHHmm")
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format("YYYYMMDDHHmm")
            : null,
          orderType: orderType,
          orderBy: orderBy,
        };
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          searchType: searchOptions.searchType,
          searchValue: searchOptions.searchValue,
          memberType: searchOptions.memberType,
          dateType: searchOptions.dateType,
          startDate: searchOptions.startDate
            ? searchOptions.startDate.format("YYYYMMDDHHmm")
            : null,
          endDate: searchOptions.endDate
            ? searchOptions.endDate.format("YYYYMMDDHHmm")
            : null,
          orderType: orderType,
          orderBy: orderBy,
        };
      }
      const res = await memberApi.readAppMemberList(param);
      if (res.code === 200) {
        setMemberList(res.result.userDTOList);
        setTotalSize(res.result.totalCnt);
        if (searchOptions.memberType === 999) {
          setNotRegisterValid(true);
        } else {
          setNotRegisterValid(false);
        }
      } else {
        alert(
          "회원 목록을 조회해오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getReadMemberList read error", error);
    }
  };

  const getPointHistoryListById = async (userId) => {
    setIsLoading(true);
    try {
      const res = await memberApi.readMemberPointHistoryList(userId);
      if (res.code === 200) {
        let earnPoint = 0;
        let usagePoint = 0;
        for (const history of res.result) {
          if (
            history.point_type === "purchase_saving_point_complete" ||
            history.point_type === "purchase_complete" ||
            history.point_type === "review_complete" ||
            history.point_type === "admin_point_complete" ||
            history.point_type === "purchase_cancel"
          ) {
            earnPoint += history.point_score;
          } else {
            usagePoint += history.point_score;
          }
        }
        setPointHistory({
          earn: earnPoint,
          usage: usagePoint,
          list: res.result,
        });
      } else {
        alert(
          "해당 회원의 포인트 상세 내역을 읽어오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getPointHistoryListById read error", error);
    }
  };

  /**
   * 회원 포인트 개별 발급
   */
  const handleEarnPoint = async () => {
    if (
      window.confirm(
        `${selectMember.nickname}님께 포인트 발급을 진행하시겠습니까?`,
      )
    ) {
      setIsLoading(true);
      try {
        const param = {
          ...earnPoint,
          user_id: selectMember.id,
          created_by: user.id,
        };
        const res = await memberApi.earnPointForMember(param);
        if (res.code === 200) {
          setIsLoading(false);
          alert(`${selectMember.nickname}님에게 포인트 발급을 완료하였습니다.`);
          handlePopoverHide();
          getPointHistoryListById(selectMember.id);
        } else if (res.code === 999) {
          throw "현재 로그인한 계정으로 해당 작업을 진행할 수 있는 권한이 없습니다.\n다른 관리자 계정으로 로그인해주시거나 관리자에게 문의해주시길 바랍니다.";
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        console.log("handleEarnPoint publish error", error);
        alert(error);
      }
    }
  };

  /**
   * 회원 권한 관리
   */
  const manageUserAuthority = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const passwordParam = {
        id: user.id,
        password: password,
      };
      const passwordRes = await userApi.reEnterPassword(passwordParam);
      if (passwordRes.code === 200) {
        if (passwordRes.result) {
          let param;
          let res;
          if (isMemberManageModalOpen.type) {
            if (isMemberManageModalOpen.type === "withdraw") {
              param = {
                user_id: selectMember.id,
                editor: user.id,
              };
              res = await userApi.userLeaveForAdmin(param);
            } else {
              param = {
                id: selectMember.id,
                created_by: user.id,
              };
              if (isMemberManageModalOpen.type === "allow") {
                res = await userApi.userAllowAdmin(param);
              } else {
                res = await userApi.userDisallowAdmin(param);
              }
            }
          } else {
            throw "서버상의 오류가 발생했습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.";
          }
          if (res.code === 200) {
            alert(
              `${selectMember.nickname}님의 정보를 성공적으로 수정하였습니다.`,
            );
            handleMemberManageModalCancel();
            getReadMemberList();
          } else {
            throw res.msg;
          }
        } else {
          throw "비밀번호가 일치하지 않습니다. 다시 시도해주십시오.";
        }
      } else {
        throw passwordRes.msg;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("manageUserAuthority error", error);
      alert(error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    switch (value) {
      case "total":
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: null,
          endDate: null,
        });
        break;
      case "today":
        setSearchOptions({
          ...searchOptions,
          dateType: value,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            dateType: value,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    setSelectedRow([]);
    setSelectedRowKey([]);
    if (searchOptions.dateType === "total") {
      if (navType === "mall") {
        getReadMemberList("search");
      } else {
        getAppReadMemberList("search");
      }
    } else {
      if (searchOptions.startDate === null || searchOptions.endDate === null) {
        alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
      } else {
        if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
          alert(
            "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
          );
        } else {
          if (navType === "mall") {
            getReadMemberList("search");
          } else {
            getAppReadMemberList("search");
          }
        }
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchTypeItems[0].searchType,
      searchText: null,
      memberType: navType === "mall" ? "general" : 0,
      dateType: "total",
      startDate: null,
      endDate: null,
    });
    setOffset(0);
    setPageSize(10);
    if (navType === "mall") {
      getReadMemberList("initial");
    } else {
      getAppReadMemberList("initial");
    }
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
    setPageSize(pageSize);
  };

  /**
   * 포인트 상세 내역 Modal cancel handler
   */
  const handleCancel = () => {
    setIsPointModalOpen(false);
    setSelectMember({});
    setPointHistory({
      earn: 0,
      usage: 0,
      list: [],
    });
    getReadMemberList();
  };

  /**
   * 개별 회원별 포인트 지급 Popover open handler
   */
  const handlePopoverOpenChange = (value) => {
    setIsEarnPointPopoverOpen(value);
    if (!value) {
      setEarnPoint({
        point_content: null,
        point_score: null,
      });
    }
  };

  /**
   * 개별 회원별 포인트 지급 Popover close handler
   */
  const handlePopoverHide = () => {
    setIsEarnPointPopoverOpen(false);
    setEarnPoint({
      point_content: null,
      point_score: null,
    });
  };

  /**
   * 회원 관리 Modal cancel handler
   */
  const handleMemberManageModalCancel = () => {
    setIsMemberManageModalOpen({ ...isMemberManageModalOpen, visible: false });
    setSelectMember({});
    setPassword(null);
  };

  const disableUserChannelJoin = () => {
    return (
      !selectedRow?.length ||
      searchOptions.memberType !== 999 ||
      !notRegisterValid
    );
  };
  const selectUserChannelJoin = () => {
    setSelectMember([...selectedRow]);
    setChannelJoinShow(true);
  };

  return (
    <>
      <ContentHeaderComponent title="회원 관리" />
      <Menu
        className={`commission-nav`}
        mode="horizontal"
        defaultSelectedKeys={["month"]}
        selectedKeys={[navType]}
      >
        <Menu.Item key={`mall`} onClick={() => setNavType("mall")}>
          당영몰 회원
        </Menu.Item>
        <Menu.Item key={`app`} onClick={() => setNavType("app")}>
          당영앱 회원
        </Menu.Item>
      </Menu>
      <div className="product-register-wrap">
        {/*회원 검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            className="center-label"
            label="검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 200, textAlign: "left" }}
            >
              {searchTypeItems.map((item, idx) => (
                <Option key={`search_type_${idx}`} value={item.searchType}>
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Input
              className="inquiry-search-input-wrap"
              placeholder="검색어를 입력하세요."
              name="searchValue"
              value={searchOptions.searchValue}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="회원 종류"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="memberType"
              options={memberTypeItems}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  [e.target.name]: e.target.value,
                })
              }
              value={searchOptions.memberType}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="가입일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={"middle"} style={{ gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={searchOptions.dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                allowClear={false}
                value={searchOptions.startDate}
                disabled={searchOptions.dateType === "total"}
                onChange={(value) => {
                  // setDateType("")
                  setSearchOptions({
                    ...searchOptions,
                    dateType: null,
                    startDate: value,
                  });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                allowClear={false}
                value={searchOptions.endDate}
                disabled={searchOptions.dateType === "total"}
                onChange={(value) => {
                  // setDateType("")
                  setSearchOptions({
                    ...searchOptions,
                    dateType: null,
                    endDate: value,
                  });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="review-search-button-wrap" justify="center">
            <Button
              className="review-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="review-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*회원 목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              회원 목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize ? totalSize?.toLocaleString() : 0}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          {navType === "app" && (
            <Row align={"middle"}>
              <Button
                className="order-excel-download-btn"
                disabled={disableUserChannelJoin()}
                onClick={selectUserChannelJoin}
              >
                선택한 회원 채널 가입
              </Button>
              {/*<Button*/}
              {/*	className="order-excel-download-btn"*/}
              {/*	// onClick={handleExcelDownloadClick}*/}
              {/*>*/}
              {/*	미가입회원 전부 채널 가입*/}
              {/*</Button>*/}
            </Row>
          )}
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            rowSelection={navType === "app" && rowSelection}
            columns={navType === "mall" ? columns : appColumns}
            dataSource={memberList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            onChange={handleTableChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              // onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>

      {/*포인트내역 Modal*/}
      {isPointModalOpen && (
        <Modal
          title="포인트 상세 내역"
          visible={isPointModalOpen}
          centered={true}
          onCancel={handleCancel}
          width={"80%"}
          wrapClassName="member-point-modal-wrap"
          footer={null}
        >
          <Row wrap={false} justify="space-between" align="middle">
            <div className="member-point-modal-content-header">
              {selectMember.nickname} 님의 포인트 내역
            </div>
            <Popover
              overlayClassName="member-earn-point-popover-wrap"
              title=""
              trigger="click"
              placement="bottomRight"
              visible={isEarnPointPopoverOpen}
              onVisibleChange={handlePopoverOpenChange}
              content={
                <div className="member-earn-point-popover-content-wrap">
                  <Row wrap={false} justify="space-between" align="middle">
                    <div className="member-earn-point-popover-header">
                      회원 포인트 개별 발급
                    </div>
                    <img
                      className="member-earn-point-popover-close"
                      src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/close.png`}
                      onClick={handlePopoverHide}
                    />
                  </Row>
                  <div className="member-earn-point-popover-content">
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="회원 아이디"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 8 }}
                    >
                      <Input value={selectMember.id} disabled={true} />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="회원 닉네임"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 8 }}
                    >
                      <Input value={selectMember.nickname} disabled={true} />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="포인트 내용"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      <Input
                        placeholder="포인트 내용을 입력해주세요."
                        name="point_content"
                        value={earnPoint.point_content}
                        onChange={(e) =>
                          setEarnPoint({
                            ...earnPoint,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      className="member-earn-point-form-wrap"
                      label="발급 포인트"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                    >
                      <Row wrap={false} align="middle">
                        <InputNumber
                          placeholder="숫자를 입력해주세요."
                          size="small"
                          formatter={(value) =>
                            value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          min={0}
                          value={earnPoint.point_score}
                          onChange={(value) => {
                            console.log("asdsa", value);
                            setEarnPoint({ ...earnPoint, point_score: value });
                          }}
                        />
                        <div className="member-earn-point-form-help-text">
                          POINT
                        </div>
                      </Row>
                    </Form.Item>
                  </div>
                  <Row
                    className="member-earn-point-button-wrap"
                    justify="center"
                  >
                    <Button
                      className="member-earn-point-button earn"
                      onClick={handleEarnPoint}
                      disabled={Object.values(earnPoint).some(
                        (value) => value === null,
                      )}
                    >
                      발급
                    </Button>
                    <Button
                      className="member-earn-point-button cancel"
                      onClick={handlePopoverHide}
                    >
                      취소
                    </Button>
                  </Row>
                </div>
              }
            >
              <Button
                className="member-earn-point-button-wrap"
                onClick={() => handlePopoverOpenChange(true)}
              >
                포인트 발급
              </Button>
            </Popover>
          </Row>
          <Table
            className="member-point-history-table-wrap"
            columns={pointColumns}
            dataSource={pointHistory.list}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="small"
            rowKey="id"
            scroll={{ x: "max-content", y: "calc(600px - 48px)" }}
            pagination={false}
          />
          <div style={{ paddingRight: 15 }}>
            <Row wrap={false}>
              <Col
                className="member-point-history-total-wrap"
                flex="auto"
                style={{ borderRight: 0 }}
              >
                소계
              </Col>
              <Col
                className="member-point-history-total-wrap"
                flex="208px"
                style={{ borderRight: 0 }}
              >
                {pointHistory.earn.toLocaleString()}
              </Col>
              <Col className="member-point-history-total-wrap" flex="208px">
                {pointHistory.usage.toLocaleString()}
              </Col>
            </Row>
            <Row wrap={false}>
              <Col
                className="member-point-history-total-wrap"
                flex="auto"
                style={{ borderTop: 0, borderRight: 0 }}
              >
                총 보유 포인트
              </Col>
              <Col
                className="member-point-history-total-wrap"
                flex="416px"
                style={{ borderTop: 0 }}
              >
                {(pointHistory.earn - pointHistory.usage).toLocaleString()}
              </Col>
            </Row>
          </div>
        </Modal>
      )}

      {/*회원관리 Modal*/}
      {isMemberManageModalOpen.visible && (
        <Modal
          title={
            isMemberManageModalOpen.type &&
            isMemberManageModalOpen.type === "allow"
              ? "관리자 권한 허용"
              : isMemberManageModalOpen.type === "disallow"
              ? "관리자 탈퇴"
              : "회원 탈퇴"
          }
          visible={isMemberManageModalOpen.visible}
          centered={true}
          onCancel={handleMemberManageModalCancel}
          wrapClassName="member-manage-modal-wrap"
          footer={[
            <Button onClick={handleMemberManageModalCancel}>취소</Button>,
            <Button
              loading={isLoading}
              disabled={!password}
              onClick={manageUserAuthority}
            >
              확인
            </Button>,
          ]}
        >
          <div>
            {isMemberManageModalOpen.type &&
            isMemberManageModalOpen.type === "allow"
              ? `${selectMember.nickname}님에게 관리자 권한을 허용하시겠습니까?`
              : isMemberManageModalOpen.type === "disallow"
              ? `${selectMember.nickname}님의 관리자 권한을 취소하시겠습니까?`
              : `${selectMember.nickname}님의 계정을 탈퇴시키겠습니까?`}
          </div>
          <div>다시 한 번 비밀번호를 입력해주세요!</div>
          <Input.Password
            className="member-manage-input-wrap"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={manageUserAuthority}
          />
        </Modal>
      )}

      {navType !== "mall" && (
        <AppUserChannel
          user={user}
          expertList={expertList}
          selectMember={selectMember}
          channelJoinShow={channelJoinShow}
          setChannelJoinShow={setChannelJoinShow}
          setSelectedRow={setSelectedRow}
          setSelectedRowKey={setSelectedRowKey}
          getAppReadMemberList={getAppReadMemberList}
        />
      )}
    </>
  );
};

const AppUserChannel = ({
  user,
  expertList,
  selectMember,
  channelJoinShow,
  setChannelJoinShow,
  setSelectedRow,
  setSelectedRowKey,
  getAppReadMemberList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectValue, setSelectValue] = useState({});
  const selectValid = !!selectMember?.length;

  useEffect(() => {
    if (channelJoinShow) {
      setSelectValue({});
    }
  }, [channelJoinShow]);

  const userChannelJoin = async () => {
    setIsLoading(true);
    if (selectValid) {
      let param = {
        userIdList: selectMember.map((item) => item.id),
        created_by: user.id === 724 ? 1 : user.id,
        channel_id: selectValue.channel_id,
      };
      const res = await memberApi.postUserChannelJoin(param);
      if (res.code === 200) {
        if (!res.result?.length) {
          alert(
            `${selectMember?.length}명의 회원이 ${selectValue.name} 채널에 가입되었습니다.`,
          );
        } else {
          // setFailList(res.result);
          alert(
            `${res.result?.length}명의 회원이 실패하였습니다. 다시 시도해주세요.\n${res.result[0].memo}`,
          );
        }
      } else {
        alert(res.msg);
      }
      getAppReadMemberList();
      setSelectedRow([]);
      setSelectedRowKey([]);
    } else {
      let param = {
        userIdList: [selectMember.id],
        created_by: user.id === 724 ? 1 : user.id,
        channel_id: selectValue.channel_id,
      };
      // console.log("userChannelJoin", param);
      const res = await memberApi.postUserChannelJoin(param);
      // console.log(res);
      if (res.code === 200) {
        alert(
          `${selectMember.name}님이 ${selectValue.name} 채널에 가입되었습니다.`,
        );
      } else {
        alert(res.msg);
        // if (res.code === 405) {
        // 	alert("새로고침 후 다시 시도해 주세요.");
        // } else if (res.code === 999) {
        // 	alert(res.msg);
        // } else if (res.code === 997) {
        // 	alert("유효한 계정이 아닙니다.");
        // } else if (res.code === 418) {
        // 	alert("이미 채널에 가입한 계정입니다.");
        // } else {
        // 	alert(
        // 		"서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다."
        // 	);
        // }
      }
      getAppReadMemberList();
    }
    setIsLoading(false);
    setChannelJoinShow(false);
  };
  return (
    <Modal
      title={selectValid ? "미가입 회원 채널 가입" : "채널 가입"}
      visible={channelJoinShow}
      centered={true}
      onCancel={() => setChannelJoinShow(false)}
      wrapClassName="member-manage-modal-wrap"
      footer={[
        <Button loading={isLoading} onClick={() => setChannelJoinShow(false)}>
          취소
        </Button>,
        <Button
          loading={isLoading}
          disabled={!selectValue.channel_id}
          onClick={userChannelJoin}
        >
          확인
        </Button>,
      ]}
    >
      {selectValid ? (
        <div>
          <strong>{selectMember?.length}</strong>명 회원에게 가입시킬 채널이름을
          선택해주세요.
        </div>
      ) : (
        <div>
          <strong>{selectMember.name}</strong>님에게 가입시켜줄 채널이름을
          선택해주세요.
        </div>
      )}
      <Select
        className="member-manage-input-wrap"
        value={selectValue.channel_id}
        onChange={
          (value) => {
            const select = expertList.filter(
              (item) => item.channel_id === value,
            );
            if (select?.length > 0) {
              setSelectValue(select[0]);
            }
          }
          // setSelectValue({ ...searchOptions, searchType: value })
        }
        style={{ width: 200, textAlign: "left" }}
      >
        {expertList.map((item, idx) => (
          <Option key={`search_type_${idx}`} value={item.channel_id}>
            {item.name}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};
export default MemberManageComponent;
